import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';

export const getUserData = createApiAction(types.GET_USER_DATA);
export const updateUserName = createAction(types.UPDATE_USER_NAME);

export const setAuthError = createAction(types.SET_AUTH_ERROR);
